import React from 'react';
import {Form, Input} from "semantic-ui-react";
import Select from "./Select";
import moment from "moment/moment";
import Info from "../Info";
import {toast} from "react-toastify";
import AddressSelect from "./AddressSelect";
import SemanticCountryPhoneInput from "../../controls/semanticCountryPhoneInput";

const InputByType = ({type, onChange, value, sourceOptionsUrl, disabled, error, maxLength, name}) => {
    switch (type) {
        case 'select':
            return <Select
                error={!!error}
                disabled={disabled}
                sourceOptionsUrl={sourceOptionsUrl}
                value={value || ''}
                onChange={(e, {value}) => onChange(value)}
            />;
        case 'address':
            return <AddressSelect
                error={error}
                disabled={disabled}
                value={value || ''}
                onChange={(name, value, e) => onChange(value, e)}
            />;
        case 'dateTimeDisabled':
            return <Input
                disabled
                value={value ? moment(value).format("DD.MM.YYYY HH:mm" ) : ''}
            />;
        case 'phone':
            return <SemanticCountryPhoneInput
                disabled={disabled}
                value={value || ''}
                onChange={(e, {value}) => onChange(value)}
                defaultCountry="ru"
            />;
        case 'text':
        default:
            return <Input
                maxLength={maxLength}
                disabled={disabled}
                value={value || ''}
                onChange={(e, {value}) => onChange(value)}
                style={name === 'additionalPhone' ? {maxWidth: '5ch'} : undefined}
            />;
    }
}
const Field = ({
                   label,
                   isRequired,
                   name,
                   value,
                   type,
                   onChange,
                   error,
                   width,
                   disabled,
                   sourceOptionsUrl,
                   info,
                   maxLength
               }) => {
    return (
        <Form.Field style={{width: width && width}} className={error ? 'error-style' : ''}>
            <label>
                {label} {isRequired && <span className="text-red">*</span>}
                {
                    info && <Info
                        key={'name'}
                        name={label}
                        position={'center'}
                        text={info}
                    />
                }
            </label>
            <InputByType
                error={error}
                name={name}
                type={type}
                value={value || ''}
                onChange={(value, e) => onChange(name, value, e)}
                sourceOptionsUrl={sourceOptionsUrl}
                disabled={disabled}
                maxLength={maxLength}
            />
        </Form.Field>
    );
};

export default Field;


// WEBPACK FOOTER //
// ./App/components/Field/index.jsx